import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

function withCommunity(payload) {
  return {
    ...(payload || {}),
    communityId: (payload && payload.communityId) || getCommunityId()
  }
}

// 查询问卷题目列表
export function listQuestionnaireTopics(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/question.listQuestionTitle',
      method: 'get',
      params: params || {}
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增问卷题目
export function saveQuestionnaireTopic(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/question.saveQuestionTitle',
      method: 'post',
      data: withCommunity(data)
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新问卷题目
export function updateQuestionnaireTopic(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/question.updateQuestionTitle',
      method: 'post',
      data: withCommunity(data)
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除问卷题目
export function deleteQuestionnaireTopic(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/question.deleteQuestionTitle',
      method: 'post',
      data: withCommunity(data)
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}
